// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"zJxre","saveBtn":"AD4Wr","close":"wYH02","closeIcon":"RLuIc"};